import { useEffect } from 'react';
import type * as maplibreglType from 'maplibre-gl';
import { useAtomValue } from 'jotai';
import { isTerrainControlerOpenAtom } from '../../atoms';

// https://github.com/geoloniamaps/smartmap-mapstyle より
export const TERRAIN_DEM_ID = "terrain";
export const TERRAIN_DEM_LAYER_ID = 'terrain/hillshade-layer';


export const addTerrainLayer = (mapObj: maplibreglType.Map, source: maplibregl.SourceSpecification, layer: maplibregl.LayerSpecification) => {

  if ( !mapObj.getSource(TERRAIN_DEM_ID) ) {
    mapObj.addSource(TERRAIN_DEM_ID, source);
  }
  
  if( !mapObj.getLayer(TERRAIN_DEM_LAYER_ID) ) {
    mapObj.addLayer(layer);
  }
}

export const useTerrainControl = ( map: maplibreglType.Map | null ) => {

  const isTerrainControlerOpen = useAtomValue(isTerrainControlerOpenAtom);

  useEffect(() => {
    if (!map) { return; }

    // ピッチ変更時の処理
    map.on('pitchend', () => {
      const currentPitch = map.getPitch();
      if (currentPitch > 0) {
        map.setLayoutProperty(TERRAIN_DEM_LAYER_ID, 'visibility', 'visible');
        map.setTerrain({ 'source': TERRAIN_DEM_ID, 'exaggeration': 1 });
      } else {
        map.setLayoutProperty(TERRAIN_DEM_LAYER_ID, 'visibility', 'none');
        map.setTerrain(null);
      }
    });

  }, [map]);

  useEffect(() => {
    if (!map) { return; }

    if (isTerrainControlerOpen) {
      map.flyTo({ pitch: 60 });
    } else {
      map.flyTo({ pitch: 0 });
    }
  }, [isTerrainControlerOpen, map]);

}
